<template>
  <div class="area-tree">
    <div class="top">
      <div class="buttons-group">
        <Button size="large" icon="md-arrow-round-back" @click="back"
          >返回</Button
        >
        <Button
          size="large"
          icon="md-add"
          type="primary"
          @click="save"
          style="margin-right: 10px"
          >保存</Button
        >
      </div>
    </div>
    <div class="bottom">
      <div class="bottonm-head">
        <table class="table table-striped table-bordered border-right-none">
          <thead>
            <tr>
              <th style="width: 30%">省</th>
              <th style="width: 30%">市</th>
              <th style="width: 40%">区</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
      <div class="bottom-body">
        <table
          height="100%"
          class="table table-striped table-bordered border-top-none border-right-none"
        >
          <tbody>
            <tr>
              <!-- province -->
              <td class="td" style="width: 30%">
                <div
                  v-for="(p, pIndex) in baseAreaAll"
                  class="column"
                  :key="p.code"
                >
                  <div
                    :class="['cell', currentP === p.code ? 'cell-active ' : '']"
                  >
                    <div
                      :class="[
                        'cb-wrap',
                        p.parentCheckStatus == 'part' ? 'cb-part-wrap' : '',
                        p.parentCheckStatus == 'all' ? 'cb-all-wrap' : '',
                      ]"
                    >
                      <input
                        type="checkbox"
                        id="checkbox"
                        :checked="p.checked"
                        @click="checkProvinceAll(p, pIndex, $event)"
                      />
                    </div>
                    <span @click="selectProvince(p, pIndex)">{{ p.name }}</span>
                  </div>
                </div>
              </td>
              <!-- city -->
              <td class="td" style="width: 30%">
                <div v-for="(p, pIndex) in baseAreaAll" :key="p.code">
                  <div class="column" v-show="currentP == p.code">
                    <div
                      v-for="(c, cIndex) in p.children || []"
                      :class="[
                        'cell',
                        currentC === c.code ? 'cell-active ' : '',
                      ]"
                      :key="c.code"
                    >
                      <div
                        :class="[
                          'cb-wrap',
                          c.parentCheckStatus == 'part' ? 'cb-part-wrap' : '',
                          c.parentCheckStatus == 'all' ? 'cb-all-wrap' : '',
                        ]"
                      >
                        <input
                          type="checkbox"
                          id="checkbox"
                          :checked="c.checked"
                          @click="checkCityAll(p, pIndex, c, cIndex, $event)"
                        />
                      </div>
                      <span @click="selectCity(c, cIndex)">{{ c.name }}</span>
                    </div>
                  </div>
                </div>
              </td>
              <!-- area -->
              <td class="td" style="width: 40%">
                <div v-for="(p, pIndex) in baseAreaAll" :key="p.code">
                  <div v-for="(c, cIndex) in p.children || []" :key="c.code">
                    <div
                      class="column"
                      v-show="currentP == p.code && currentC == c.code"
                    >
                      <div
                        class="cell"
                        v-for="(a, aIndex) in c.children || []"
                        :key="a.code"
                      >
                        <div
                          :class="['cb-wrap', a.checked ? 'cb-all-wrap' : '']"
                        >
                          <input
                            type="checkbox"
                            id="checkbox"
                            :checked="a.checked"
                            @click="
                              areaCheckChange(
                                p,
                                pIndex,
                                c,
                                cIndex,
                                a,
                                aIndex,
                                $event
                              )
                            "
                          />
                        </div>
                        <span>{{ a.name }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      currentP: 0,
      currentC: 0,
      selectArea: {},
    };
  },
  computed: {
    ...mapGetters("base", {
      baseAreaAll: "getBaseAreaAll",
    }),
    ...mapGetters("merchant", {
      spAreaList: "getSpAreaList",
    }),
  },
  watch: {
    baseAreaAll: function (newv) {
      this.selectProvince(newv[0], 0);
      this.selectCity(newv[0].children[0], 0);
    },
  },
  created() {
    this.$Spin.show();
    this.$store
      .dispatch("base/getBaseAreaAll")
      .then(() => {
        this.$store
          .dispatch("merchant/getSpAreaList", {
            page: 1,
            pageSize: 10000,
            spCode: this.$route.query.code,
          })
          .then(this.setValue);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(this.$Spin.hide);
  },
  methods: {
    setValue() {
      if (
        this.spAreaList &&
        this.spAreaList.data &&
        this.spAreaList.data.length
      ) {
        this.baseAreaAll.forEach((p, pIndex) => {
          if (p.children && p.children.length) {
            p.children.forEach((c, cIndex) => {
              if (c.children && c.children.length) {
                c.children.forEach((area, index) => {
                  this.spAreaList.data.forEach((v) => {
                    if (v.areaCode == area.code) {
                      this.areaCheckChange(p, pIndex, c, cIndex, area, index, {
                        target: { checked: true },
                      });
                    }
                  });
                });
              }
            });
          }
        });
      }
    },
    selectProvince(p, index) {
      this.$set(this, "currentP", p.code);
    },
    selectCity(c, index) {
      this.$set(this, "currentC", c.code);
    },
    checkProvinceAll(p, pIndex, event) {
      (p.children || []).forEach((c, i) => {
        this.checkCityAll(p, pIndex, c, i, event);
      });
    },
    checkCityAll(p, pIndex, c, cIndex, event) {
      (c.children || []).forEach((a, i) => {
        this.areaCheckChange(p, pIndex, c, cIndex, a, i, event);
      });
    },
    areaCheckChange(p, pIndex, c, cIndex, a, aIndex, event) {
      const flag = event.target.checked;
      this.$set(a, "checked", flag);
      const ckey = "" + c.code;
      // 选中
      if (flag) {
        // 记录当前area code
        if (!this.selectArea[ckey]) {
          this.$set(this.selectArea, ckey, new Array(c.children.length));
        }

        this.selectArea[ckey].splice(aIndex, 1, a);
      }
      // 取消选中
      else {
        // 清空当前area code
        this.selectArea[ckey].splice(aIndex, 1, false);
      }

      // 判断当前区域选择数量
      // step1: city
      const cStatus = this.judgeAreaNumber(
        this.selectArea[ckey].filter((i) => !!i).length,
        c.children.length
      );
      this.$set(p.children[cIndex], "parentCheckStatus", cStatus);
      // step2: province
      // 获取当前已选择城市数量
      let count = 0;
      p.children.forEach((c) => {
        if (c.parentCheckStatus == "all" || c.parentCheckStatus == "part") {
          count++;
        }
      });
      const pStatus = this.judgeAreaNumber(count, p.children.length);
      this.$set(this.baseAreaAll[pIndex], "parentCheckStatus", pStatus);

      // console.log("已经选中: ", this.selectArea);
    },
    judgeAreaNumber(checkLen, allLen) {
      // 全部选中
      if (checkLen >= allLen) {
        return "all";
      }
      // 部分选中
      else if (checkLen > 0) {
        return "part";
      }
      // 没有选中
      else {
        return "none";
      }
    },
    save() {
      const areaCodeList = [];
      Object.keys(this.selectArea).forEach((key) => {
        this.selectArea[key]
          .filter((i) => !!i)
          .forEach((a) => areaCodeList.push(a.code));
      });
      // console.log(areaCodeList);

      this.$store
        .dispatch("merchant/shopInfoUpdateArea", {
          areaCodeList,
          spCode: this.$route.query.code,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$Message.success("保存成功");
            setTimeout(this.back, 3000);
          } else {
            this.$Message.error(res.message || "保存失败");
          }
        })
        .catch((err) => {
          this.$Message.error("保存失败");
        });
    },
    back() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
/* 滚动条宽度 */
::-webkit-scrollbar {
  width: 0;
  background-color: transparent;
}

/* 滚动条颜色 */
::-webkit-scrollbar-thumb {
  background-color: #27314d;
}

.area-tree {
  position: relative;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.top {
  flex: 0 0 auto;
}

.bottom {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  height: 80vh;
  overflow: hidden;
}

.bottonm-head {
  flex: 0 0 auto;
}

.bottom-body {
  flex: 1 1 auto;
  overflow: auto;
  border-bottom: 1px solid #e7e7e7;
}

.buttons-group {
  text-align: right;
  padding: 0 0 20px 0;
  width: 100%;
}

.table {
  table-layout: fixed;
  width: 100%;
  max-width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  background-color: transparent;
}

tbody {
  display: table-row-group;
  vertical-align: top;
  border-color: inherit;
}

.table-striped > tbody .cell {
  line-height: 1.42857;
  padding: 8px;
  cursor: default;
}

.table,
.table thead,
.table tbody,
.table tr,
.table tr th,
.table tr td {
  display: block;
  height: 100%;
  overflow: hidden;
}

.table thead tr,
.table tbody tr {
  display: flex;
}

.table tbody tr td {
  overflow: auto;
}

.table > tbody > tr > th,
.table > tfoot > tr > td,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > thead > tr > th {
  border-top: 1px solid #e7eaec;
  line-height: 1.42857;
  padding: 8px;
  vertical-align: top;
}

.table > tbody > tr > td {
  border-top: 1px solid #e7eaec;
  line-height: 1.42857;
  vertical-align: top;
}

.table-bordered > tbody > tr > td,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > td,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > thead > tr > th {
  border: 1px solid #e7e7e7;
}

.border-top-none,
.border-top-none > tbody > tr > td,
.border-top-none > tbody > tr > th,
.border-top-none > tfoot > tr > td,
.border-top-none > tfoot > tr > th,
.border-top-none > thead > tr > td,
.border-top-none > thead > tr > th {
  border-top: none;
  border-bottom: none;
}

.border-right-none,
.border-right-none > tbody > tr > td:not(:last-child),
.border-right-none > tbody > tr > th:not(:last-child),
.border-right-none > tfoot > tr > td:not(:last-child),
.border-right-none > tfoot > tr > th:not(:last-child),
.border-right-none > thead > tr > td:not(:last-child),
.border-right-none > thead > tr > th:not(:last-child) {
  border-right: none;
}

.cb-wrap {
  display: inline-block;
  width: 16px;
  height: 16px;
  position: relative;
  border-color: #2d8cf0;
  background-color: #ffffff;
  border: 1px solid #dcdee2;
  border-radius: 2px;
  overflow: hidden;
  transition: border-color 0.2s ease-in-out, background-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;
}

.cb-wrap input {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
}

.cb-part-wrap {
  background-color: #2d8cf0;
}

.cb-all-wrap {
  background-color: #2d8cf0;
}

.cb-part-wrap::after {
  content: "";
  width: 10px;
  height: 1px;
  transform: scale(1);
  position: absolute;
  left: 2px;
  top: 6px;
  display: table;
  position: absolute;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transition: all 0.2s ease-in-out;
}
.cb-all-wrap::after {
  content: "";
  display: table;
  width: 4px;
  height: 8px;
  position: absolute;
  top: 2px;
  left: 5px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1);
  transition: all 0.2s ease-in-out;
}

.cell {
  display: flex;
  align-items: center;
  line-height: 1.42857;
  padding: 8px;
  cursor: default;
}

.cell-active {
  /* color: white; */
  background-color: rgba(45, 140, 240, 0.3);
}

.cell span {
  flex: 1 1 auto;
  margin-left: 6px;
}
</style>


// WEBPACK FOOTER //
// src/views/merchant/manage/area.vue